import request from '@/api'

// 用户相关API
export const userApi = {
  login(data) {
    return request({
      url: '/login',
      method: 'post',
      data
    })
  },

  passwordLogin(data) {
    return request({
      url: '/login/password',
      method: 'post',
      data
    })
  },

  register(data) {
    return request({
      url: '/register',
      method: 'post',
      data
    })
  },

  resetPassword(data) {
    return request({
      url: '/reset_password',
      method: 'post',
      data
    })
  },

  sendCode(data) {
    return request({
      url: '/send_code',
      method: 'post',
      data
    })
  },


  // 获取用户信息
  getUserInfo() {
    return request({
      url: "/account/info",
      method: "get",
    });
  },

  // 用户登出
  logout() {
    return request({
      url: "/logout",
      method: "get",
    });
  },
};